// load script librery
import AOS from 'aos';
import 'aos/dist/aos.css';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/src/ScrollTrigger';
//load script
import mobileMenu from './js/header.js';
import scroll from './js/scroll.js';
import gsapTitle from './js/gsapTitle.js';
import gsapScroll from './js/gsapScroll.js';
import gsapText from './js/gsapText.js';
import swiperSlides from './js/swiper.js';
// import { message } from './js/message.js';
import openText from './js/openText.js';

// SCRIPT >

document.addEventListener('DOMContentLoaded', () => {
  // init and load DOM
  document.querySelector('.wrapper').classList.add('loaded');
  gsap.registerPlugin(ScrollTrigger);
  AOS.init({ once: true, duration: 400, offset: 80 });
  // snipper script
  scroll(ScrollTrigger);
  gsapTitle(gsap);
  gsapScroll(gsap);
  gsapText(gsap);
});

// scripts section
mobileMenu();
swiperSlides();
// message();
openText();
